import { Component } from '@angular/core';
import { SetupGuideStep } from '../setup-guide/setup-guide.component';

/**
 * Page wrapper for the Square integration settings.
 *
 * Hosts the settings form and connected devices alongside the shared setup
 * guide inside the standard configuration page shell.
 */
@Component({
  selector: 'app-integration-square',
  templateUrl: './integration-square.component.html',
  styleUrls: ['./integration-square.component.css'],
})
export class IntegrationSquareComponent {
  setupSteps: SetupGuideStep[] = [
    {
      num: 1,
      title: 'Authorize Square',
      body: `Click <strong>Authorize Square</strong>. You’ll be redirected to Square to log in
             and allow access to your account.`,
      open: true,
    },
    {
      num: 2,
      title: 'Log in & allow',
      body: `Sign in (or create an account), review the requested permissions, and click
             <strong>Allow</strong> to proceed.`,
    },
    {
      num: 3,
      title: 'Confirm & select location',
      body: `You’ll be redirected back here, now connected. Choose your <strong>location</strong>
             and click <strong>Save Settings</strong>.`,
    },
    {
      alt: true,
      title: 'Disconnecting',
      body: `Click <strong>Deauthorize</strong> to revoke the application’s access. A confirmation
             message will follow.`,
    },
  ];
}
